import React from 'react';
import css from './AddonsSectionMaybe.module.css';
import { addonsTypeOptions } from '../../util/general';

const AddonsSectionMaybe = ({ listing }) => {
  const upsellingItems = listing?.attributes?.publicData?.upsellingItems;

  if (!upsellingItems || upsellingItems?.length < 1) {
    return null;
  }
  return (
    <div className={css.sectionAddons}>
      <p className={css.sectionTitle}>Packages</p>
      <div className={css.addonsWrapper}>
        {upsellingItems.map(item => {
          const priceLabel = item?.priceAmount / 100;
          const typeLabel = addonsTypeOptions.find(i => i.key === item.type[0])?.label;
          return (
            <div className={css.item}>
              <span className={css.itemSection}>
                {/* {'• '} */}
                <b>{item.label}</b>
              </span>
              <br/>
              {item.description}
              <b/>
              <br/>
              <span className={css.itemSection}>{`($${priceLabel} / ${typeLabel})`}</span>
            </div>
          );
        })}
      </div>
      <br/>
      <br/>
    </div>
    
  );
};

export default AddonsSectionMaybe;
